import React from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  CardActions,
  CardContent,
  Checkbox,
  Divider,
  FormControlLabel,
  Grid,
  Paper,
} from '@availity/element';

import { Footer, EssentialsUserAgreement, AvailityHeaderLogo } from '@/components';
import { useAppContext } from '@/context';

const UserAgreementPage = ({ ...props }) => {
  const { stepToRender, setCurrentStep } = props;
  const navigate = useNavigate();
  const { setUserAgreementStatus, addMessage } = useAppContext();

  // initialize form
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm({
    defaultValues: {
      agreed: '',
    },
  });

  const agreedValue = watch('agreed');

  const onSubmit = () => {
    setUserAgreementStatus({ essentialsAgreement: true });
    setCurrentStep(stepToRender);
  };

  return (
    <Grid
      id="user-agreement-page-grid-container"
      container
      display="flex"
      flexDirection="row"
      flexWrap="wrap"
      spacing={0}
      sx={{ minHeight: '100vh', justifyContent: 'center' }}
    >
      <Grid
        size={{ xs: 12, sm: 12, md: 6 }}
        display="flex"
        flexDirection="column"
        alignItems="center"
        flexGrow={1}
        sx={{ minHeight: '100vh' }}
      >
        <AvailityHeaderLogo />
        <Grid direction="column" alignItems="center" justifyContent="center">
          <Paper
            variant="elevation"
            elevation={6}
            sx={{ width: { xs: '350px', sm: '500px', md: '700px', lg: '1000px' } }}
          >
            <form onSubmit={handleSubmit(onSubmit)}>
              <CardContent>
                <Box>
                  <EssentialsUserAgreement />
                </Box>
                <Divider sx={{ margin: 2 }} />
                <FormControlLabel
                  error={!!errors.agreed}
                  control={
                    <Checkbox
                      {...register('agreed', {
                        required: 'You must accept the agreement to use the Availity portal.',
                      })}
                    />
                  }
                  label='If You are in agreement with the foregoing, please indicate by clicking on the "I Agree" button below.'
                />
              </CardContent>
              <CardActions sx={{ justifyContent: 'end' }}>
                <Button
                  color="secondary"
                  onClick={() => {
                    addMessage('You must accept the agreement to use the Availity portal.');
                    navigate('/logout');
                  }}
                >
                  I Decline
                </Button>
                <Button color="primary" disabled={!agreedValue} type="submit">
                  I Agree
                </Button>
              </CardActions>
            </form>
          </Paper>
        </Grid>
        <Footer />
      </Grid>
    </Grid>
  );
};

UserAgreementPage.propTypes = {
  stepToRender: PropTypes.object.isRequired,
  setCurrentStep: PropTypes.func.isRequired,
};

export default UserAgreementPage;
